import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, ArrowRight, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

const productNames = [
    "Premium Basmati Rice",
    "Wheat",
    "Onion",
    "Sesame Seeds",
    "Pulses",
    "Groundnut",
    "Corn Seeds",
    "Guar Gum",
    "Chicken Egg",
    "Cotton Yarn",
    "Cumin Seeds",
    "Coriander Seeds",
    "Fennel Seeds",
    "Chili Powder",
    "Coriander Powder",
    "Turmeric Powder",
    "Cumin Powder"
];

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-gray-300 z-50 relative">
            {/* Newsletter Section */}
            {/* <div className="relative z-10 bg-green-900">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                        <div>
                            <h3 className="text-2xl font-bold text-white mb-2">Subscribe to our Newsletter</h3>
                            <p className="text-green-200">Get the latest updates on international trade and market trends.</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col sm:flex-row gap-3">
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                className="w-full sm:w-80 px-6 py-3 rounded-full bg-green-800/50 text-white placeholder-green-300 border border-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-transparent transition-all"
                            />
                            <button className="px-8 py-3 bg-white text-green-900 rounded-full font-bold hover:bg-green-50 transform hover:scale-105 transition-all duration-300 shadow-lg">
                                Subscribe
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Company Info */}
                    <div className="space-y-6">
                        <div className="flex items-center gap-2">
                            <div className="bg-gradient-to-br from-green-500 to-teal-500 p-2 rounded-lg">
                                <Globe className="w-6 h-6 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">
                                Nurani Enterprise
                            </h2>
                        </div>
                        <p className="text-gray-400 leading-relaxed">
                            Connecting businesses worldwide with premium quality products and seamless export solutions. Your trusted partner in global trade excellence.
                        </p>
                        <div className="flex gap-4 pt-4">
                            {[Facebook, Twitter, Instagram, Linkedin].map((Icon, index) => (
                                <a
                                    key={index}
                                    href="#"
                                    className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-green-600 hover:text-white transition-all duration-300 transform hover:-translate-y-1"
                                >
                                    <Icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-bold text-white mb-6 border-b-2 border-green-600 inline-block pb-1">Quick Links</h3>
                        <ul className="space-y-4">
                            {[
                                { name: 'Home', path: '/' },
                                { name: 'About Us', path: '/about' },
                                { name: 'Products', path: '/products' },
                                { name: 'Contact', path: '/contact' }
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="flex items-center group text-gray-400 hover:text-green-500 transition-colors"
                                    >
                                        <ArrowRight className="w-4 h-4 mr-2 transform group-hover:translate-x-1 transition-transform" />
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Products */}
                    <div>
                        <h3 className="text-lg font-bold text-white mb-6 border-b-2 border-green-600 inline-block pb-1">
                            Products
                        </h3>

                        <ul className="space-y-4 max-h-64 overflow-y-auto pr-2">
                            {productNames.map((name, index) => (
                                <li
                                    key={index}
                                    className="flex items-start gap-3 text-gray-400 hover:text-green-500 transition-colors duration-300"
                                >
                                    <div className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2"></div>
                                    <span className="hover:translate-x-1 transition-transform duration-300 cursor-pointer">
                                        {name}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-bold text-white mb-6 border-b-2 border-green-600 inline-block pb-1">Contact Us</h3>
                        <ul className="space-y-6">
                            <li className="flex items-start gap-4">
                                <div className="bg-gray-800 p-2 rounded-lg text-green-500 shrink-0">
                                    <MapPin className="w-5 h-5" />
                                </div>
                                <span className="text-gray-400">
                                    Royal Complex, Shop no. 2,<br />
                                    JinPara Main Road, Wankaner,<br />
                                    Gujarat, India - 363621
                                </span>
                            </li>
                            <li className="flex items-center gap-4">
                                <div className="bg-gray-800 p-2 rounded-lg text-green-500 shrink-0">
                                    <Phone className="w-5 h-5" />
                                </div>
                                <a
                                    href="tel:+916352068269"
                                    className="text-gray-400 hover:text-green-500"
                                >
                                    +91 63520 68269
                                </a>
                            </li>

                            <li className="flex items-center gap-4">
                                <div className="bg-gray-800 p-2 rounded-lg text-green-500 shrink-0">
                                    <Mail className="w-5 h-5" />
                                </div>
                                <a
                                    href="https://mail.google.com/mail/?view=cm&fs=1&to=sales.nuranienterprise@gmail.com&su=Trade Inquiry&body=Hello Nurani Enterprise,"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-green-500"
                                >
                                    sales.nuranienterprise@gmail.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="border-t border-gray-800 bg-gray-950">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-gray-500 text-center md:text-left">
                            © {new Date().getFullYear()} Nurani Enterprise. All rights reserved.
                        </p>
                        <div className="flex gap-6 text-sm text-gray-500">
                            <a href="#" className="hover:text-green-500 transition-colors">Privacy Policy</a>
                            <a href="#" className="hover:text-green-500 transition-colors">Terms of Service</a>
                            <a href="#" className="hover:text-green-500 transition-colors">Sitemap</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;